import { emptySocialSignupInfo, SocialSignupInfo } from 'login/LoginService';
import { IfPtnr, PtnrEntity } from 'models/partner-v2/IfPtnr';
import { create } from 'zustand';

export interface LoginInputValues {
  id: string;
  password: string;
}

export type ZstdHeader = {
  setCountrySelect: (v: boolean) => void;
  countrySelect: boolean;
  langSelect: boolean;
  setLangSelect: (v: boolean) => void;
  isPartner: boolean;
  setIsPartner: (v: boolean) => void;
  setIsLoadingUserPopup: (v: boolean) => void;
  isLoadingUserPopup: boolean;

  ptnr: IfPtnr;
  setPtnr: (v: IfPtnr) => void;
  isPtnrUser: () => boolean;
  doneFetchPtnr: boolean;
  setDoneFetchPtnr: (v: boolean) => void;

  setAlertAlarmCount: (v: number) => void;
  alertAlarmCount: number;
  setAlertNewAlarm: (v: boolean) => void;
  alertNewAlarm: boolean;
  setLoginInputValues: (v: LoginInputValues) => void;
  loginInputValues: LoginInputValues;

  setShowLoginFailPopup: (v: boolean) => void;
  showLoginFailPopup: boolean;
  setSignupEmail: (v: string) => void;
  signupEmail: string;
  socialSignupInfo: SocialSignupInfo;
  setSocialSignupInfo: (v: SocialSignupInfo) => void;
  setTermsType: (v: string) => void;
  termsType: string;
  resetPasswordEmail: string;
  setResetPasswordEmail: (v: string) => void;
};
export const useZstdHeader = create<ZstdHeader>((set, get) => ({
  setCountrySelect: (v: boolean) => set({ countrySelect: v }),
  countrySelect: false,
  setLangSelect: (v: boolean) => set({ langSelect: v }),
  langSelect: false,
  setIsPartner: (v: boolean) => set({ isPartner: v }),
  isPartner: false,

  ptnr: new PtnrEntity(),
  setPtnr: (v: IfPtnr) => set({ ptnr: v }),
  isPtnrUser: () => {
    const id = get().ptnr?.ptnrId;
    if (typeof id !== 'number') return false;
    return id > 0;
  },
  doneFetchPtnr: false,
  setDoneFetchPtnr: (v: boolean) => set({ doneFetchPtnr: v }),

  setIsLoadingUserPopup: (v: boolean) => set({ isLoadingUserPopup: v }),
  isLoadingUserPopup: false,
  setAlertNewAlarm: (v: boolean) => set({ alertNewAlarm: v }),
  alertNewAlarm: false,
  setAlertAlarmCount: (v: number) => set({ alertAlarmCount: v }),
  alertAlarmCount: undefined,
  setLoginInputValues: (v: LoginInputValues) => set({ loginInputValues: v }),
  loginInputValues: { id: '', password: '' },
  setShowLoginFailPopup: (v: boolean) => set({ showLoginFailPopup: v }),
  showLoginFailPopup: false,
  setSignupEmail: (v: string) => set({ signupEmail: v }),
  signupEmail: '',
  socialSignupInfo: { ...emptySocialSignupInfo },
  setSocialSignupInfo: (v: SocialSignupInfo) => set({ socialSignupInfo: v }),
  setTermsType: (v: string) => set({ termsType: v }),
  termsType: '',
  resetPasswordEmail: '',
  setResetPasswordEmail: (v: string) => ({ resetPasswordEmail: v }),
}));
